import React from 'react'
import { Box, Icon, Message } from 'react-bulma-components'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import { jobTitleKeys, useJobTitleQuery } from '../../queries/job-titles'
import JobTitleForm from '../../components/job-titles/job-title-form'
import JobTitleExplanation from '../../components/job-titles/job-title-explanation'
import useUrlId from '../../hooks/use-url-id'
import FormWrapper from '../../components/form/form-wrapper'
import { useFormWrapperPropsWithMutationData } from '../../hooks/use-form-wrapper-props-with-mutation-data'
import { useMutationState } from '../../queries'
import JobTitleDangerZone from '../../components/job-titles/job-title-danger-zone'
import { WarningIcon } from '../../components/icons'

/**
 * Composant pour afficher et éditer les détails d'un métier
 */
const JobTitleDetails: React.FC = () => {
  //const { employer } = useOutletContext<OutletContext>()
  const { id, isNew } = useUrlId()

  const { data: jobTitle } = useJobTitleQuery(id, {
    enabled: Boolean(id),
  })

  const mutationState = useMutationState(isNew ? jobTitleKeys.create : jobTitleKeys.update)
  const formWrapperProps = useFormWrapperPropsWithMutationData(
    formWrapperBaseProps,
    //@ts-ignore
    mutationState,
    !isNew,
  )

  return (
    <>
      <SidebarContentTitle
        title={isNew ? 'Nouveau métier' : `Détails du métier ${jobTitle?.name}`}
        help={<JobTitleExplanation textColor={'white'} />}
      />
      {jobTitle?.isInactive && (
        <Message color="warning">
          <Message.Body>
            <Icon.Text>
              <Icon>
                <WarningIcon />
              </Icon>
              Ce métier est actuellement inactif et ne peut pas être utilisé pour de nouvelles
              missions.
            </Icon.Text>
          </Message.Body>
        </Message>
      )}
      <FormWrapper {...formWrapperProps}>
        <Box>
          <JobTitleForm jobTitle={jobTitle} />
        </Box>
        {!isNew && jobTitle && <JobTitleDangerZone jobTitle={jobTitle} />}
      </FormWrapper>
    </>
  )
}

export default JobTitleDetails

const formWrapperBaseProps = {
  loadingProps: { body: 'Enregistrement du métier...' },
  successProps: {
    title: 'Métier créé',
    body: {
      description: 'Le métier a été créé',
      actions: [
        {
          label: 'Nouveau Métier',
        },
        {
          label: 'Retourner à la liste',
          to: '/settings/job-titles',
        },
      ],
    },
  },
}
